<ng-template #assignPopup>
    <div class="ng-template-container">
        <div class="page-loading-shade" *ngIf="isProcessing">
            <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
        </div>
        <button class="close close-button" (click)="closeAssignPopup()" mat-button>
            <i class="fa popupClose">&#xf00d;</i></button>
        <div mat-dialog-title>
            <label for="title" class="popupTitle"> Assign Training </label>
            <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
        </div>
        <div class="form-continer" style="max-height: 500px;">
            <div class="row">
                <div class="col-md-8" [hidden]="changeInCriteria">
                    <mat-radio-group class="tp-radio-group" [(ngModel)]="selectedTrainingCriteria">
                        <mat-radio-button class="tp-radio-button" color="primary"
                            *ngFor="let criteria of searchCriteriaOptions" [value]="criteria"
                            (change)="onSearchCriteriaChanged(criteria)">
                            {{criteria}}
                        </mat-radio-button>
                    </mat-radio-group>
                </div>
                <div class="col-md-4 hyperref" style="margin-top :11px;">
                    <a (click)="openAssignedGroupsPopup()"
                        *ngIf="selectedTrainingCriteria == 'One training → Multiple groups' && training.trainingName">
                        Click here to see assigned groups for selected training
                    </a>
                </div>
            </div><br />

            <div class="row" *ngIf="selectedTrainingCriteria">
                <div class="col-md-6"
                    *ngIf="selectedTrainingCriteria == 'One training → Multiple groups' || training.groupId">
                    <div>
                        <label id="training-name" for="email">{{dynamicLabel['TRAINING_NAME']}}</label>
                        <span class="mandatory-symbol">*</span>&nbsp;
                        <span
                            *ngIf="selectedTrainingCriteria != 'One training → Multiple groups' && training.trainingName"
                            (click)="openViewPopup('Training(s)')" (keydown.enter)="openViewPopup('Training(s)')">
                            <i class="fa fa-eye"></i>
                        </span>
                    </div>
                    <div style="display: flex; justify-content: flex-start;">
                        <div class="col-sm-11" style="position: relative;">
                            <input id="trainingName" class="input-filed-continers" type="text"
                                style="cursor: not-allowed;" [matTooltip]="training.trainingName!"
                                [(ngModel)]="training.trainingName" [disabled]="true"
                                (onNgModelChange)="onNgModelChange(training.trainingName, 'training-name')">
                        </div>
                        <div class="col-sm-1" *ngIf="!changeInCriteria"
                            style="padding-left: 2%; margin-top: 1%; font-size: 16px; color: red; cursor: pointer;"
                            (click)="searchTraining()" (keydown.enter)="searchTraining()">
                            <i class="fa fa-search"></i>
                        </div>
                    </div>
                </div>

                <div class="col-md-6">
                    <div>
                        <label id="group" for="email">Group</label>
                        <span class="mandatory-symbol">*</span>&nbsp;
                        <span
                            *ngIf="selectedTrainingCriteria == 'One training → Multiple groups' && selectedGroupIds.length"
                            (click)="openViewPopup('Group(s)')" (keydown.enter)="openViewPopup('Group(s)')">
                            <i class="fa fa-eye"></i>
                        </span>
                    </div>
                    <mat-select *ngIf="selectedTrainingCriteria == 'Multiple trainings → One group'" matInput
                        placeholder="Select" [(ngModel)]="training.groupId" (closed)="groupSearchText=''"
                        (click)="focusSearch('focus-group')" (keydown.enter)="focusSearch('focus-group')">
                        <input type="search" id="focus-group" class="dropdownsearchstyle" [(ngModel)]="groupSearchText"
                            matInput placeholder="search">
                        <mat-option [value]="null" class="unselectStyle"
                            (onSelectionChange)="onGroupSelect($event, null)">Un-select</mat-option>
                        <mat-option *ngFor="let item of groupDropdown | assessmentSearch : groupSearchText"
                            [value]="item.valueExp" (selectionChange)="onGroupSelect($event, item)"
                            (onSelectionChange)="onGroupSelect($event, item)">
                            {{ item.displayExp }}
                        </mat-option>
                    </mat-select>
                    <mat-select *ngIf="selectedTrainingCriteria == 'One training → Multiple groups'" matInput multiple
                        placeholder="Select" #group [(ngModel)]="selectedGroupIds" (closed)="groupSearchText = ''"
                        (click)="focusSearch('focus-multi-group')" (keydown.enter)="focusSearch('focus-multi-group')">
                        <input type="search" id="focus-multi-group" class="dropdownsearchstyle"
                            [(ngModel)]="groupSearchText" matInput placeholder="search">
                        <div class="select-all">
                            <mat-checkbox [(ngModel)]="isAllGroupSelected" (change)="toggleAllGroup()"
                                (onSelectionChange)="onMultiGroupSelect($event, null)">
                                Select All
                            </mat-checkbox>
                        </div>
                        <mat-option *ngFor="let item1 of groupDropdown | multiAssessmentSearchPipe :groupSearchText"
                            [value]="item1" (selectionChange)="onMultiGroupSelect($event,item1)"
                            (onSelectionChange)="onMultiGroupSelect($event, item1)">
                            {{ item1.displayExp }}
                        </mat-option>
                    </mat-select>
                </div>

                <ng-container *ngIf="selectedTrainingCriteria == 'One training → Multiple groups' || training.groupId">
                    <div class="col-md-3">
                        <div>
                            <label id="level" for="email">{{dynamicLabel['TRAINING_LEVEL']}}</label>
                            <span class="mandatory-symbol">*</span>
                        </div>
                        <mat-select matInput placeholder="Select" [(ngModel)]="training.trainingLevel"
                            (closed)="trainingLevelSearchText = ''" (click)="focusSearch('focus-level')"
                            (keydown.enter)="focusSearch('focus-level')">
                            <input type="search" id="focus-level" class="dropdownsearchstyle"
                                [(ngModel)]="trainingLevelSearchText" matInput placeholder="Search">
                            <mat-option class="unselectStyle" [value]="null"
                                (onSelectionChange)="onLevelSelect($event,null);">Un-select</mat-option>
                            <mat-option
                                *ngFor="let item of trainingLevelDropdown | assessmentSearch : trainingLevelSearchText"
                                (onSelectionChange)="onLevelSelect($event,item)" [value]="item.valueExp">
                                {{ item.displayExp }}
                            </mat-option>
                        </mat-select>
                    </div>

                    <div class="col-md-3">
                        <div><label for="email">Training Template</label></div>
                        <mat-select matInput placeholder="Select" [(ngModel)]="training.trainingTemplate"
                            (closed)="trainingTemplateSearchText = ''" (click)="focusSearch('focus-template')"
                            (keydown.enter)="focusSearch('focus-template')">
                            <input type="search" id="focus-template" class="dropdownsearchstyle"
                                [(ngModel)]="trainingTemplateSearchText" matInput placeholder="Search">
                            <mat-option class="unselectStyle" [value]="null"
                                (onSelectionChange)="onTemplateSelect($event, null);">Un-select</mat-option>
                            <mat-option
                                *ngFor="let item of trainingTemplateDropdown | assessmentSearch : trainingTemplateSearchText"
                                (onSelectionChange)="onTemplateSelect($event, item)" [value]="item.valueExp">
                                {{ item.displayExp }}
                            </mat-option>
                        </mat-select>
                    </div>

                    <div class="col-md-3">
                        <div><label for="email">{{dynamicLabel['DUE_N_DAY_FROM_ASSIGNED']}}</label></div>
                        <input id="dueNDayFromAssigned" class="input-filed-continers" type="number" min="1"
                            [(ngModel)]="training.dueNDayFromAssigned" (keydown)="validateNumberFields($event)">
                    </div>

                    <div class="col-md-3">
                        <div><label for="email">{{dynamicLabel['REMIND_N_DAY_BEFORE_DUE']}}</label></div>
                        <input id="remindNDayBeforeDue" class="input-filed-continers" type="number" min="1"
                            [(ngModel)]="training.remindNDayBeforeDue" (keydown)="validateNumberFields($event)">
                    </div>

                    <div class="col-md-3">
                        <div><label for="email">{{dynamicLabel['REMIND_EVERY_N_DAYS']}}</label></div>
                        <input id="remindEveryNDays" class="input-filed-continers" type="number" min="1"
                            [(ngModel)]="training.remindEveryNDays" (keydown)="validateNumberFields($event)">
                    </div>

                    <div class="col-md-3">
                        <div><label for="email">{{dynamicLabel['ESCALATE']}}</label></div>
                        <mat-slide-toggle color="primary" [(ngModel)]="training.escalate" (ngModelChange)="onEscalateChange()">
                            <span class="active-inActive-container" *ngIf="training.escalate==true"
                                [ngStyle]="training.escalate==true?{'color':'green'} : {'color': ''}">Yes</span>
                            <span *ngIf="training.escalate==false"
                                [ngStyle]="training.escalate==false?{'color':'red'} : {'color': ''}">No</span>
                        </mat-slide-toggle>
                    </div>

                    <div class="col-md-3" *ngIf="training.escalate">
                        <div><label for="email">{{dynamicLabel['ESCALATE_EVERY_N_DAYS']}}</label></div>
                        <input id="escalateEveryNDays" class="input-filed-continers" type="number" min="1"
                            [(ngModel)]="training.escalateEveryNDays" (keydown)="validateNumberFields($event)">
                    </div>

                    <div class="col-md-3">
                        <div><label for="email">{{dynamicLabel['REPEAT_TRAINING']}}</label></div>
                        <mat-slide-toggle color="primary" [(ngModel)]="training.repeatTraining" (ngModelChange)="onRepeatTrainingChange()">
                            <span class="active-inActive-container" *ngIf="training.repeatTraining==true"
                                [ngStyle]="training.repeatTraining==true?{'color':'green'} : {'color': ''}">Yes</span>
                            <span *ngIf="training.repeatTraining==false"
                                [ngStyle]="training.repeatTraining==false?{'color':'red'} : {'color': ''}">No</span>
                        </mat-slide-toggle>
                    </div>

                    <div class="col-md-3" *ngIf="training.repeatTraining">
                        <div><label for="email">{{dynamicLabel['REPEAT_INTERVAL']}}</label></div>
                        <input id="repeatInterval" class="input-filed-continers" type="number" min="1"
                            [(ngModel)]="training.repeatInterval" (keydown)="validateNumberFields($event)">
                    </div>

                    <div class="col-md-3" *ngIf="training.repeatTraining">
                        <div><label for="email">{{dynamicLabel['REPEAT_INTERVAL_UNIT']}}</label></div>
                        <mat-select matInput placeholder="Select" [(ngModel)]="training.repeatIntervalUnit"
                            (closed)="repeatIntervalSearchText=''" (click)="focusSearch('focus-interval')"
                            (keydown.enter)="focusSearch('focus-interval')">
                            <input type="search" id="focus-interval" class="dropdownsearchstyle"
                                [(ngModel)]="repeatIntervalSearchText" matInput placeholder="Search">
                            <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
                            <mat-option
                                *ngFor="let item of repeatIntervalDropdown | assessmentSearch :repeatIntervalSearchText"
                                [value]="item.valueExp">
                                {{ item.displayExp }}
                            </mat-option>
                        </mat-select>
                    </div>

                    <div class="col-md-3">
                        <div><label for="email">{{dynamicLabel['ALLOWED_FAILED_ATTEMPTS']}}</label>
                            <span
                                matTooltip="The allowed number of assessment attempts before the training is locked(A)"
                                matTooltipPosition="above" class="info-icon" style="margin-left: 5px; cursor: pointer;">
                                <i class="fas fa-info-circle"></i>
                            </span>
                        </div>
                        <input id="allowedFailedAttempts" class="input-filed-continers" type="number" min="1"
                            [(ngModel)]="training.allowedFailedAttempts" (keydown)="validateNumberFields($event)">
                    </div>

                    <div class="col-md-3">
                        <div><label for="email">
                                {{dynamicLabel['ALLOWED_FAILED_ATTEMPTS_AFTER_UNLOCK']}}</label> <span
                                matTooltip="The allowed number of re-assessment attempts after being unlocked (B)"
                                matTooltipPosition="above" class="info-icon" style="margin-left: 5px; cursor: pointer;">
                                <i class="fas fa-info-circle"></i>
                            </span></div>
                        <input id="allowedFailedAttemptsAfterUnlock" class="input-filed-continers" type="number" min="1"
                            [(ngModel)]="training.allowedFailedAttemptsAfterUnlock"
                            (keydown)="validateNumberFields($event)">
                    </div>

                    <div class="col-md-3">
                        <div><label for="email">{{dynamicLabel['MAX_ALLOWED_FAILED_ATTEMPTS']}}</label>
                            <span
                                matTooltip="The maximum allowed attempts before the training gets permanently locked(C > A+ B)"
                                matTooltipPosition="above" class="info-icon" style="margin-left: 5px; cursor: pointer;">
                                <i class="fas fa-info-circle"></i>
                            </span>
                        </div>
                        <input id="maxAllowedFailedAttempts" class="input-filed-continers" type="number" min="1"
                            [(ngModel)]="training.maxAllowedFailedAttempts" (keydown)="validateNumberFields($event)">
                    </div>

                    <div class="col-md-3">
                        <div><label for="email">{{dynamicLabel['DUE_N_DAY_FROM_OVERDUE_UNLOCK']}}</label></div>
                        <input id="dueNDayFromOverdueUnlock" class="input-filed-continers" type="number" min="1"
                            [(ngModel)]="training.dueNDayFromOverdueUnlock" (keydown)="validateNumberFields($event)">
                    </div>

                    <div class="col-md-3">
                        <div><label for="email"> {{dynamicLabel['RETAKE_AFTER_N_MIN_ON_FAILED_ATTEMPT']}}</label></div>
                        <input id="retakeAfterNMinOnFailedAttempt" class="input-filed-continers" type="number" min="1"
                            [(ngModel)]="training.retakeAfterNMinOnFailedAttempt"
                            (keydown)="validateNumberFields($event)">
                    </div>

                    <div class="col-md-3">
                        <div><label for="email">{{dynamicLabel['ALLOW_TO_REVIEW_RESULTS']}}</label></div>
                        <mat-slide-toggle color="primary" [(ngModel)]="training.allowToReviewResults" (ngModelChange)="onAllowToReviewResultsChange()">
                            <span class="active-inActive-container" *ngIf="training.allowToReviewResults==true"
                                [ngStyle]="training.allowToReviewResults==true?{'color':'green'} : {'color': ''}">Yes</span>
                            <span *ngIf="training.allowToReviewResults==false"
                                [ngStyle]="training.allowToReviewResults==false?{'color':'red'} : {'color': ''}">No</span>
                        </mat-slide-toggle>
                    </div>

                    <div class="col-md-3">
                        <div><label for="email">{{dynamicLabel['SHOW_ANSWERS_AT_REVIEW']}}</label></div>
                        <mat-slide-toggle color="primary" [(ngModel)]="training.showAnswersAtReview">
                            <span class="active-inActive-container" *ngIf="training.showAnswersAtReview==true"
                                [ngStyle]="training.showAnswersAtReview==true?{'color':'green'} : {'color': ''}">Yes</span>
                            <span *ngIf="training.showAnswersAtReview==false"
                                [ngStyle]="training.showAnswersAtReview==false?{'color':'red'} : {'color': ''}">No</span>
                        </mat-slide-toggle>
                    </div>

                    <div class="col-md-3">
                        <div><label for="email">{{dynamicLabel['OVERDUE_RM_APPROVAL_REQD']}}</label></div>
                        <mat-slide-toggle color="primary" [(ngModel)]="training.overdueRmApprovalReqd">
                            <span class="active-inActive-container" *ngIf="training.overdueRmApprovalReqd==true"
                                [ngStyle]="training.overdueRmApprovalReqd==true?{'color':'green'} : {'color': ''}">Yes</span>
                            <span *ngIf="training.overdueRmApprovalReqd==false"
                                [ngStyle]="training.overdueRmApprovalReqd==false?{'color':'red'} : {'color': ''}">No</span>
                        </mat-slide-toggle>
                    </div>

                    <div class="col-md-3">
                        <div><label for="email">{{dynamicLabel['OVERDUE_QA_APPROVAL_REQD']}}</label></div>
                        <mat-slide-toggle color="primary" [(ngModel)]="training.overdueQaApprovalReqd"
                          (ngModelChange)="onQaApprovalRequestedChange()">
                            <span class="active-inActive-container" *ngIf="training.overdueQaApprovalReqd==true"
                                [ngStyle]="training.overdueQaApprovalReqd==true?{'color':'green'} : {'color': ''}">Yes</span>
                            <span *ngIf="training.overdueQaApprovalReqd==false"
                                [ngStyle]="training.overdueQaApprovalReqd==false?{'color':'red'} : {'color': ''}">No</span>
                        </mat-slide-toggle>
                    </div>

                    <div class="col-md-6" *ngIf="training.overdueQaApprovalReqd">
                        <div>
                            <label for="email" id="qa">{{dynamicLabel['LIST_OF_QA_USER_NAMES']}}</label>
                            <span class="mandatory-symbol">*</span>
                        </div>
                        <mat-select matInput multiple placeholder="Select" #qa [(ngModel)]="selectedQaUsers"
                            (closed)="qaSearchText=''" (click)="focusSearch('focus-qa')"
                            (keydown.enter)="focusSearch('focus-qa')">
                            <input type="search" id="focus-qa" class="dropdownsearchstyle" [(ngModel)]="qaSearchText"
                                matInput placeholder="search">
                            <div class="select-all">
                                <mat-checkbox [(ngModel)]="isAllQaSelected" (change)="toggleAllQa()">
                                    Select All
                                </mat-checkbox>
                            </div>
                            <mat-option *ngFor="let item1 of qaDropdown | multiAssessmentSearchPipe :qaSearchText"
                                [value]="item1.valueExp" (onSelectionChange)="onQaSelect($event,item1)">
                                {{ item1.displayExp }}
                            </mat-option>
                        </mat-select>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>
    <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions
        *ngIf="selectedTrainingCriteria && (selectedTrainingCriteria == 'One training → Multiple groups' || training.groupId)">
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="assignTraining()"
            (keydown.enter)="assignTraining()">
            <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
            <span class="reload_text text-white">Assign</span>
        </div>
        <button mat-stroked-button class="cancelButton" (click)="closeAssignPopup()">
            <i class="fa fa-close"></i> Cancel
        </button>
    </div>
</ng-template>

<ng-template #searchTrainingPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelSearchTrainingPopup()" mat-button>
        <i class="fa popupClose">&#xf00d;</i>
    </button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle"> Search Training </label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="search-popup">
        <div class="row">
            <div class="col-md-3">
                <div><label for="email">Training Name</label></div>
                <input class="search-filed-continers" type="text" [(ngModel)]="searchByTrainingName">
            </div>
            <div class="col-md-3">
                <div><label for="email">Training Code</label></div>
                <input class="search-filed-continers" type="text" [(ngModel)]="searchByTrainingCode">
            </div>
            <div class="col-md-3">
                <div><label for="email">Category</label></div>
                <mat-select matInput placeholder="Select" [(ngModel)]="searchByCategory"
                    (closed)="categorySearchText=''" (click)="focusSearch('focus-categpry')"
                    (keydown.enter)="focusSearch('focus-categpry')">
                    <input type="search" id="focus-categpry" class="dropdownsearchstyle"
                        [(ngModel)]="categorySearchText" matInput placeholder="Search">
                    <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
                    <mat-option *ngFor=" let item of categoryDropdown | assessmentSearch :categorySearchText"
                        [value]="item.valueExp">
                        {{ item.displayExp }}
                    </mat-option>
                </mat-select>
            </div>
            <div class="col-md-3">
                <div><label for="email">Language</label></div>
                <mat-select matInput placeholder="Select" [(ngModel)]="searchByLanguage"
                    (closed)="languageSearchText=''" (click)="focusSearch('focus-language')"
                    (keydown.enter)="focusSearch('focus-language')">
                    <input type="search" id="focus-language" class="dropdownsearchstyle"
                        [(ngModel)]="languageSearchText" matInput placeholder="Search">
                    <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
                    <mat-option *ngFor="let item of languageDropdown | assessmentSearch :languageSearchText"
                        [value]="item.valueExp">
                        {{ item.displayExp }}
                    </mat-option>
                </mat-select>
            </div>
        </div>
        <div class="row">
            <div class="button-continer btn-align" mat-dialog-actions>
                <button mat-stroked-button class="addButton" (click)="getTrainings()">
                    <i class="fa-solid fa-magnifying-glass"></i> Search
                </button>
                <button mat-stroked-button class="cancelButton" *ngIf="!trainingsList.length"
                    (click)="cancelSearchTrainingPopup()">
                    <i class="fa fa-close"></i> Cancel
                </button>
                <button mat-stroked-button class="cancelButton"
                    *ngIf="searchByTrainingName || searchByTrainingCode || searchByCategory || searchByLanguage || trainingsList.length"
                    (click)="resetSearchTrainingPopup()">
                    <i class="fas fa-undo"></i> Reset
                </button>
            </div>
        </div>
        <div class="table-container" *ngIf="trainingsList.length">
            <table style="max-height: 45vh;">
                <thead>
                    <th style="min-width: 60px; text-align: center;">
                        <div style="display: flex;">
                            <div>
                                <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
                            </div>
                            <div style="margin-left: 5px;"
                                *ngIf="selectedTrainingCriteria == 'Multiple trainings → One group'">
                                <input type="checkbox" style="zoom: 1.2;" [(ngModel)]="parentCheckBox"
                                    (change)="onParentCheckBoxChanged($event)">
                            </div>
                        </div>
                    </th>

                    <th
                        [ngStyle]="{'min-width': '100px','max-width': '300px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>Training Name</span>
                        </div>
                    </th>

                    <th
                        [ngStyle]="{'min-width': '100px','max-width': '350px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>Training Code</span>
                        </div>
                    </th>

                    <th
                        [ngStyle]="{'min-width': '100px','max-width': '250px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>Version</span>
                        </div>
                    </th>

                    <th
                        [ngStyle]="{'min-width': '100px','max-width': '250px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>Category</span>
                        </div>
                    </th>

                    <th
                        [ngStyle]="{'min-width': '140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>Training Type</span>
                        </div>
                    </th>

                    <th
                        [ngStyle]="{'min-width': '140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>Language</span>
                        </div>
                    </th>

                    <th id="menu" class="sticky-col first-col"></th>
                </thead>
                <tbody>
                    <tr class="data-row-container" *ngFor="let training of trainingsList; let idx = index;">
                        <td style="min-width: 80px; text-align: center;">
                            <div style="display: flex;">
                                <div [ngClass]="training.childCheckBox ?'static_icon':'hover-menu-icons'">
                                    <i class="fa-solid fa-ellipsis-vertical"></i>
                                </div>
                                <div style="margin-left: 5px;">
                                    <input id="selectedUserCheckBox`" type="checkbox" style="zoom: 1.2;"
                                        [checked]="training.childCheckBox"
                                        (change)="selectedTrainingCriteria == 'Multiple trainings → One group' ? onChildCheckBoxChanged($event, training, idx) : onChecked($event, training)">
                                </div>
                            </div>
                        </td>
                        <td class="row-data">{{ training.trainingName }}</td>
                        <td class="row-data">{{ training.trainingCode }}</td>
                        <td class="row-data">{{ training.version }}</td>
                        <td class="row-data">{{ training.categoryCode }}</td>
                        <td class="row-data">{{ training.type }}</td>
                        <td class="row-data">{{ training.language }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="button-continer btn-align" mat-dialog-actions *ngIf="trainingsList.length">
            <button mat-stroked-button class="addButton" (click)="selectTraining()"
                [ngStyle]="isAddDisabled ? { cursor: 'not-allowed' } : {}" [disabled]="isAddDisabled">
                <i class="fas fa-check"></i> Add
            </button>
            <button mat-stroked-button class="cancelButton" (click)="cancelSearchTrainingPopup()">
                <i class="fa fa-close"></i> Cancel
            </button>
        </div>
    </div>
</ng-template>

<ng-template #resultPopup>
    <div class="ng-template-container">
        <div class="page-loading-shade" *ngIf="isProcessing">
            <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
        </div>
        <button class="close close-button" (click)="cancelResultPopup()" mat-button><i
                class="fa popupClose">&#xf00d;</i></button>
        <div mat-dialog-title>
            <label for="title" class="popupTitle"> {{popupTitle}} </label>
            <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
        </div>
        <div class="table-container" style="margin: 10px;">
            <table style="max-height: 65vh;">
                <thead>
                    <th
                        [ngStyle]="{'min-width': '100px','max-width': '300px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>Training Name</span>
                        </div>
                    </th>
                    <th
                        [ngStyle]="{'min-width': '100px','max-width': '300px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>Training Group</span>
                        </div>
                    </th>

                    <th
                        [ngStyle]="{'min-width': '100px','max-width': '350px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>Result</span>
                        </div>
                    </th>

                </thead>
                <tbody>
                    <tr class="data-row-container" *ngFor="let r of responses; let idx = index;">
                        <td class="row-data">{{ r.training }}</td>
                        <td class="row-data">{{ r.group }}</td>
                        <td class="row-data"
                            [ngStyle]=" r.response.resultType == 'S' ? {'color': 'green'} :{'color':'red'}">
                            {{ r.response.result }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
        <button mat-stroked-button class="cancelButton" (click)="cancelResultPopup()">
            <i class="fa fa-close"></i> Cancel
        </button>
    </div>
</ng-template>

<ng-template #assignedGroupPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAssignedGroupsPopup()" mat-button>
        <i class="fa popupClose">&#xf00d;</i>
    </button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle"> Assigned Groups </label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="search-popup">
        <div class="table-container" style="margin: 10px;">
            <table style="max-height: 65vh;">
                <thead>
                    <th
                        [ngStyle]="{'min-width': '100px','max-width': '300px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>Training Code</span>
                        </div>
                    </th>

                    <th
                        [ngStyle]="{'min-width': '100px','max-width': '300px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>Training Name</span>
                        </div>
                    </th>

                    <th
                        [ngStyle]="{'min-width': '100px','max-width': '250px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>Version</span>
                        </div>
                    </th>

                    <th
                        [ngStyle]="{'min-width': '100px','max-width': '250px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>Status</span>
                        </div>
                    </th>

                    <th
                        [ngStyle]="{'min-width': '100px','max-width': '250px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>Is Latest Published</span>
                        </div>
                    </th>

                    <th *ngFor="let header of headerList; let idx = index;" class="vertical-heading">
                        <span title="{{header}}">{{header}}</span>
                    </th>

                </thead>
                <tbody>
                    <tr class="data-row-container" *ngFor="let row of pagedItems; let idx = index;">
                        <td *ngFor="let cell of row; let iVal = index;">
                            <span *ngIf="iVal <= 3"> {{ cell}}</span>

                            <span *ngIf="iVal==4 && cell=='Y'">
                                <div class="icon-container" [ngClass]="{'green-icon': true}">
                                    <img src="../../assets/img/accessSymbol.svg" width="20" height="20"
                                        alt="Access granted symbol">
                                </div>
                            </span>
                            <span *ngIf="iVal==4 && cell=='N'">
                                <div class="icon-container" [ngClass]="{'green-icon': true}">
                                    <img *ngIf="row.isEnabled === 'N'" src="../../assets/img/noAcessSymbol.svg"
                                        width="20" height="20" alt="Access granted symbol">
                                </div>
                            </span>
                            <span *ngIf="iVal > 4 && cell==1">
                                <div class="icon-container" [ngClass]="{'green-icon': true}">
                                    <img src="../../assets/img/accessSymbol.svg" width="20" height="20"
                                        alt="Access granted symbol">
                                </div>
                            </span>
                            <span *ngIf="iVal > 4 && cell==0"></span>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="d-flex justify-content-center">
                <div class="width-cheat small paginationCell">
                    <div class="d-flex align-items-center gap-3">
                        <div class="pagination_text mt-3">
                            {{ showingRowsText }}
                            1-{{ perPage }} of {{ collectionSize | number }}
                        </div>
                        <div>
                            <ngb-pagination class="leftpadding" (pageChange)="setPage(pager.currentPage, $event)"
                                [disabled]="false" [collectionSize]="pager.totalItems" [(page)]="pager.currentPage"
                                [maxSize]="maxSize" [rotate]="true" [pageSize]="perPage" [ellipses]="false"
                                [boundaryLinks]="true" size="sm">
                            </ngb-pagination>
                        </div>
                        <div ngbDropdown class="mt-3">
                            <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" id="dropdownBasic1"
                                ngbDropdownToggle>
                                {{ perPage }}
                                <i class="ms-1 fa-solid fa-chevron-down"></i>
                            </button>
                            <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                                <button ngbDropdownItem (click)="paginationCall(10)">10</button>
                                <button ngbDropdownItem (click)="paginationCall(20)">20</button>
                                <button ngbDropdownItem (click)="paginationCall(50)">50</button>
                            </div>
                            per page
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #viewPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="closeViewPopup()" mat-button>
        <i class="fa popupClose">&#xf00d;</i>
    </button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle"> {{ viewPopupTitle}}</label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div style="margin: 15px 15px;">
        <div>
            <div class="row">
                <textarea type="text" class="input-filed-textarea" rows="8" cols="50" [(ngModel)]="viewModel"
                    [disabled]="true"></textarea>
            </div>
        </div>
    </div>
</ng-template>